module.exports = __webpack_public_path__ + "static/img/ble-bg-key-dem.4c3dfa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/blekey/key1/ble-bg-key-dem.png
// module id = PaUH
// module chunks = 0